// extracted by mini-css-extract-plugin
export default {"videoContainer":"denRp9z2D7Bo1OJnFwMx"};